import React from 'react';
import { t, translate, getLanguage } from 'react-switch-lang';

import { Form, FormSpy } from 'react-final-form';
import { Amount as AmountField } from './Field';
import MapleButton from './MapleButton';
import { formatCurrency, invalidFormAlert } from '../utils/Helpers';
import { validateAmount, validateRequired } from '../utils/Validation';
import { formatAmountFr, formatAmountEn } from '../utils/Format';
import { events } from '../utils/Amplitude';

function LoadForm({
  onSubmit,
  setAmount,
  load,
  amount,
  setError,
  loading,
  feeLabel = t('ReloadFee_Lbl'),
  paymentPage = false,
}) {
  const lang = getLanguage();
  const total = amount + load.fee;

  function formatSubmitButtonDescription() {
    if (validateAmount(amount, load.max, load.min) !== undefined) {
      return t('MyCard_LoadFunds_Btn');
    }
    return t('ButtonDescription_LoadFunds_StartPaymentInfo')
      .replace('xTotal', formatCurrency(total))
      .replace('xSubtotal', formatCurrency(amount));
  }

  const validate = (values) => {
    const errors = {};
    let normalizedAmountStr = `${values.amount || 0}`.replaceAll('$', '').replace(/\s/g, '');
    normalizedAmountStr = lang === 'fr' ? normalizedAmountStr.replace(',', '.') : normalizedAmountStr.replaceAll(',', '');
    const parsedAmount = parseFloat(normalizedAmountStr || 0);
    errors.amount = validateRequired(parsedAmount) ?
      t('MyCard_LoadFunds_Field_Amount_Help').replace('xMin', formatCurrency(load.min, true)).replace('xMax', formatCurrency(load.max, true)) :
      validateAmount(parsedAmount, load.max, load.min);
    setAmount(parsedAmount);

    return errors;
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={(values) => validate(values)}
      render={({ handleSubmit, form: { change }, invalid, errors }) => (
        <form onSubmit={(event) => {
          invalidFormAlert(invalid, errors, true);
          handleSubmit(event);
        }}
        >
          <FormSpy
            subscription={{ active: true, touched: true }}
            onChange={({ touched, active }) => {
              if (touched.amount && active !== 'amount') {
                if (!amount) return;
                change('amount', formatCurrency(amount));
              }
            }}
          />
          <div className="reloadFormContainer">
            <div className="row reloadAmountContainer">
              <div className="col-md-8 my-auto">
                <label htmlFor="LoadAmountInput">
                  <span className="loadAmtLbl">{t('MyCard_LoadFunds_Field_Amount_Lbl')}</span>
                  <span className="loadAmtDisclaimer">
                    {t('MyCard_LoadFunds_Field_Amount_Help')
                      .replace('xMin', formatCurrency(load.min, true))
                      .replace('xMax', formatCurrency(load.max, true))}
                  </span>
                </label>
              </div>

              <div className="col-md-4">
                <AmountField
                  id="LoadAmountInput"
                  name="amount"
                  format={lang === 'fr' ? formatAmountFr : formatAmountEn}
                  placeholder={lang === 'fr' ? '0,00 $' : '$0.00'}
                />
              </div>
            </div>

            <LineItem id="fee" label={feeLabel} value={load.fee} />
            <LineItem id="total" label={t('Total_Lbl')} value={total} className="important" />

            <div className="loadFundsInner">
              {paymentPage && <p>{t('MyCard_LoadFunds_TermsAndConditions')}</p>}
              <p className={`notice ${paymentPage ? 'text-start' : 'text-center'}`}>{t('Reload_eTransferMinimumAmount')}</p>

              <MapleButton
                color="dark"
                type="submit"
                className="px-5"
                ariaLabel={formatSubmitButtonDescription()}
                text={t('Continue_Btn')}
                ampEvent={paymentPage ?
                  events.USER_CLICKED_START_PAYMENT_PURCHASE :
                  events.USER_CLICKED_RELOAD_START_PAYMENT_BUTTON}
                ampEventProps={{ 'Total Amount CAD': total.toFixed(2) }}
                onClickEvent={() => setError('')}
                loading={loading}
              />
            </div>
          </div>
        </form>
      )}
    />

  );
}

function LineItem({ label, value, className = '', id }) {
  return (
    <div id={id} className={`loadFundsLineItem ${className}`}>
      <span className="loadFundsLineLbl">{label}</span>
      <span className="loadFundsLineVal">{formatCurrency(value)}</span>
    </div>
  );
}

export default translate(LoadForm);
